import { render, staticRenderFns } from "./PartnerNewIframe.vue?vue&type=template&id=729953f4&"
import script from "./PartnerNewIframe.vue?vue&type=script&lang=ts&"
export * from "./PartnerNewIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports